var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-select grid gap-2",class:[
    ("grid-cols-" + _vm.columns)
  ]},_vm._l((_vm.list),function(item){return _c('span',{key:item.key,staticClass:"p-2 text-xs rounded text-center cursor-pointer border duration-100",class:{
      'text-gray-400 border-gray-300 hover:text-gray-500 hover:border-gray-400': !_vm.selection.includes(item.key),
      'text-red-400 border-red-400 hover:text-red-300 hover:border-red-300': _vm.selection.includes(item.key)
    },on:{"click":function () {_vm.manageSelection(item.key)}}},[_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }